/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { AssignTeam } from "api/models";
import { getAssignTeam } from "api/services/quotation";
import { quotationQueryKeys } from "./quotationQueryKeys";

type GetAssignedTeamsOptions = {
  id: string;
  config?: any;
  options?: UseQueryOptions;
};

export const useGetAssignedTeams = ({ id, config, options }: GetAssignedTeamsOptions) =>
  useQuery<any, Error, AssignTeam[], any>({
    queryKey: quotationQueryKeys.assignedTeamList(id, config),
    queryFn: () => getAssignTeam(id, config).then((res) => res.data),
    ...options,
  });
